import { Circle, Icon, type SquareProps } from '@chakra-ui/react';
import { Check } from 'lucide-react';

interface RadioCircleProps extends SquareProps {
  isCompleted: boolean;
  isActive: boolean;
}

export function StepCircle(props: RadioCircleProps) {
  const { isCompleted, isActive, ...restProps } = props;
  return (
    <Circle
      size="8"
      bg={isCompleted ? 'accent' : 'inherit'}
      borderWidth={isCompleted ? '0' : '2px'}
      borderColor={isActive ? 'accent' : 'inherit'}
      data-testid={isCompleted ? 'completed-circle' : 'outer-circle'}
      {...restProps}
    >
      {isCompleted ? (
        <Icon as={Check} color="fg.inverted" boxSize="5" />
      ) : (
        <Circle bg={isActive ? 'accent' : 'border'} size="3" data-testid="inner-circle" />
      )}
    </Circle>
  );
}
